module.exports = __webpack_public_path__ + "static/img/ai.230105a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/traffic/ai.png
// module id = 6gg7
// module chunks = 1